import { FC } from "react";

import isNumber from "lodash/isNumber";

import Typography from "@mui/material/Typography";

import { STORE_VERSIONS } from "enums/storeTypes";

import {
  MIN_REDEEM_SHIPMENT_DAYS,
  MAX_REDEEM_SHIPMENT_DAYS,
} from "utils/redeem";

type ShippingInfoProps = {
  storeType: STORE_VERSIONS;
  minShipmentDays?: number | null;
  maxShipmentDays?: number | null;
  isRedeemed?: boolean;
};

const ShippingInfo: FC<ShippingInfoProps> = ({
  storeType,
  minShipmentDays,
  maxShipmentDays,
  isRedeemed = false,
}) => {
  const shipmentDays =
    isNumber(minShipmentDays) && isNumber(maxShipmentDays)
      ? {
          minShipmentDays,
          maxShipmentDays,
        }
      : {
          minShipmentDays: MIN_REDEEM_SHIPMENT_DAYS,
          maxShipmentDays: MAX_REDEEM_SHIPMENT_DAYS,
        };

  return (
    <>
      <Typography variant="h4" gutterBottom>
        SHIPPING & PRODUCTION
      </Typography>
      <Typography paragraph sx={{ mb: 0 }}>
        {storeType === STORE_VERSIONS.PARTNER ? "Partner" : "Uniqly"} is
        responsible for production and shipping of this product. The delivery of
        this item takes from {shipmentDays.minShipmentDays} to{" "}
        {shipmentDays.maxShipmentDays} days.
        {storeType === STORE_VERSIONS.PARTNER && !isRedeemed
          ? " Shipping price of the physical version of this item is between 0 and 50 USD."
          : ""}
      </Typography>
    </>
  );
};

export default ShippingInfo;
